import React from "react";
import { SEO, DriversMain, AdminLayout } from "../../../components";

const DriversMainPage = () => {
  return (
    <>
      <SEO title="Drivers" />
      <AdminLayout>
        <DriversMain />
      </AdminLayout>
    </>
  );
};

export default DriversMainPage;
